import * as React                                   from "react";
import { ReactNode }                                from "react";
import { connect }                                  from "react-redux";
import { Dispatch }                                 from "redux";
import GetPublishNotice                             from "../../application/usecase/notice/GetPublishNotice";
import MenuType                                     from "../../domain/menu/MenuType";
import Notices                                      from "../../domain/notice/Notices";
import { ResKaState }                               from "../../index";
import RightPositionSection                         from "../components/common/layout/RightPositionSection";
import NoticeList                                   from "../components/notice/NoticeList";
import OfficeSelector                               from "../components/common/OfficeSelector";
import ResKaBaseContainer, { BaseProps, BaseState } from "./ResKaBaseContainer";

interface Props extends BaseProps {
  notices: Notices;
  getPublishNotice: GetPublishNotice;
}

class NoticeContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state: BaseState = {
      menuType: MenuType.NOTICE,
      headerTitle: "お知らせ"
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getPublishNotice.execute();
  }

  protected renderInternal(): ReactNode {
    const {notices} = this.props;
    return (
      <>
        <RightPositionSection>
          <OfficeSelector/>
        </RightPositionSection>
        <NoticeList notices={ notices }/>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  notices: state.notices,
  fetchStatus: state.fetchStatus,
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  getPublishNotice: new GetPublishNotice(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoticeContainer);
